<template>
  <div class="comment-content">
    <div class="top" v-if="total">最新评论 {{ total }}条</div>
    <div class="comment-list">
      <div class="comment-mask" v-if="!isApp" @click.stop></div>
      <div
        class="comment-item"
        v-for="(item, index) in data"
        :key="index"
        @click.stop="bindChat(item)"
        @touchstart="bindtouchstart(item, index)"
        @touchmove="bindtouchmove"
        @touchend="bindtouchend"
      >
        <div class="item-avatar" @click.stop="clickAvatar(item)">
          <van-image class="avatar" :src="item.head_img" fit="cover" />
          <img
            class="flag"
            v-if="item.label_data && item.label_data.length"
            :src="item.label_data[0].icon"
            alt=""
          />
        </div>
        <div class="item-right">
          <div class="item-top">
            <div class="item-center">
              <div class="item-nickname">{{ item.truename }}</div>
              <div class="desc">{{ item.label_data | filterDesc }}</div>
            </div>
            <div class="like" @click.stop="clickLike(item)">
              <ZanIcon :flag="item.flag" class="iconfont" />
              <span>{{ item.zan_num }}</span>
            </div>
          </div>
          <div class="item-words">{{ item.comment }}</div>
          <div class="item-time">{{ item.addtime | filterCommentTime }}</div>
          <!-- 子评论 -->
          <div
            class="item-children"
            v-if="item.comment_list && item.comment_list.length"
          >
            <div
              class="child-item"
              @click.stop="bindChat(item, item1)"
              v-for="(item1, index1) in item.comment_list"
              :key="index1"
              v-show="index1 < limit || item.open"
              @touchstart.stop="bindtouchstart(item1, index, index1)"
              @touchmove.stop="bindtouchmove"
              @touchend.stop="bindtouchend"
            >
              <div class="c-left">
                <div class="c-l-top">
                  <span>{{ item1.truename }}</span
                  ><span v-if="item1.t_unify_id != item.unify_id"
                    ><span class="reply">回复</span
                    ><span>{{ item1.t_truename }}</span></span
                  >
                </div>
                <div class="c-words">{{ item1.comment }}</div>
                <div class="c-time"
                  ><span>{{ item1.addtime | filterCommentTime }}</span
                  ><span> 回复</span>
                </div>
              </div>
              <div class="c-right" @click.stop="clickLike(item1)">
                <ZanIcon class="iconfont" :flag="item1.flag" />
                <div>{{ item1.zan_num }}</div>
              </div>
            </div>
            <div
              class="show-more"
              v-if="item.comment_list.length > 2"
              @click.stop="item.open = !item.open"
            >
              {{ item.open ? '收起' : '查看全部'
              }}{{ item.comment_list.length }}条回复</div
            >
          </div>
        </div>
      </div>
    </div>
    <div class="not-more" v-if="finished && total"
      >没有更多评论了,快发布一条吧...</div
    >
    <div class="not-data" v-if="finished && !total">
      <img
        class="not-data-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3be9ea8aa66beb90fd4d31cda0a6a9f.png"
        alt=""
      />
      <div class="not-data-text">快来发表你的评论吧</div>
    </div>
  </div>
</template>
<script>
import dataObj from '@/common/date.js'
import ZanIcon from './zan.vue'
export default {
  props: {
    finished: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number | String,
      default: 0
    }
  },
  components: {
    ZanIcon
  },
  filters: {
    filterDesc(labels) {
      if (!labels.length) {
        return ''
      }
      return (labels[0] && labels[0].alias) || ''
    },
    filterCommentTime(time) {
      let commentTime = new Date(time.replace(/-/g, '/'))
      let res = dataObj.handleCommentDate(commentTime)
      return res
    }
  },
  data() {
    return {
      longPressTime: 600,
      limit: 2,
      isApp: false
    }
  },
  created() {
    this.isApp = this.$http._isApp()
  },
  methods: {
    //点击头像
    clickAvatar(item) {
      this.$emit('avatar', item)
    },
    clickLike(item) {
      this.$emit('like', item)
    },
    bindChat(item, item1) {
      this.$emit('chat', item, item1)
    },
    bindLongPress(item, index, index1) {
      this.$emit('longpress', item, index, index1)
    },
    bindtouchstart(item, index, index1) {
      if (this.timeOutEvent) {
        clearTimeout(this.timeOutEvent) //清除定时器
      }
      this.timeOutEvent = setTimeout(() => {
        this.bindLongPress(item, index, index1)
      }, this.longPressTime) //这里设置定时
    },
    bindtouchmove() {
      clearTimeout(this.timeOutEvent) //清除定时器
    },
    bindtouchend() {
      if (this.timeOutEvent) {
        clearTimeout(this.timeOutEvent) //清除定时器
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.comment-content {
  background: #fff;
  padding: 20px;

  .top {
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 21px;
    margin-bottom: 20px;
  }

  .comment-list {
    position: relative;
    .comment-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 99;
    }
    .comment-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 21px;

      .item-avatar {
        margin-right: 10px;
        position: relative;

        .avatar {
          width: 36px;
          height: 36px;
          overflow: hidden;
          border-radius: 50%;
        }

        .flag {
          height: 15px;
          position: absolute;
          bottom: 0;
          right: 0;
          transform: translate(20%, 0%);
        }
      }

      .item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .item-top {
          display: flex;
          align-items: center;
          margin-bottom: 13px;

          .item-center {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;

            .item-nickname {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 17px;
            }

            .desc {
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.6);
              line-height: 14px;
            }
          }

          .like {
            font-size: 10px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.3);
            line-height: 14px;
            display: flex;
            align-items: center;

            .iconfont {
              margin-right: 8px;
              color: rgb(221, 221, 221);
            }

            .like-active {
              color: #6236ff;
            }
          }
        }

        .item-words {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 22px;
          margin-bottom: 3px;
          word-break: break-all;
          white-space: pre-wrap;
        }

        .item-time {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 14px;
          margin-bottom: 10px;
        }

        .item-children {
          background: #f7f7f7;
          border-radius: 5px;
          padding: 15px;

          .child-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 17px;

            .c-left {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;

              .c-l-top {
                margin-bottom: 3px;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.5);
                line-height: 17px;

                .reply {
                  font-weight: 400;
                  margin-left: 4px;
                  margin-right: 4px;
                }
              }

              .c-words {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 22px;
                margin-bottom: 3px;
                word-break: break-all;
                white-space: pre-wrap;
              }

              .c-time {
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.5);
                line-height: 14px;
              }
            }

            .c-right {
              text-align: center;
              font-size: 10px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.3);
              line-height: 14px;

              .iconfont {
                margin-bottom: 2px;
                color: rgb(221, 221, 221);
              }

              .like-active {
                color: #6236ff;
              }
            }
          }

          .child-item:last-child {
            margin-bottom: 0px;
          }

          .show-more {
            margin-top: 10px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #2882e9;
            line-height: 17px;
          }
        }
      }
    }
  }

  .not-more {
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
  }

  .not-data {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .not-data-image {
      width: 138px;
      margin-bottom: 10px;
    }

    .not-data-text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
